module.exports = __webpack_public_path__ + "static/media/Circo2024_16.0284de0a.webp";